var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useIntl } from "react-intl";
import { dynamicMessage } from "translation";
/**
 * Render an input with an optional label and help text, and an error message when validation fails.
 */
export function InputWrapper(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (_jsxs("div", { id: `${props.input.name}-wrapper`, className: "form-group form-wrapper", children: [_jsx(RenderLabelAndHelpText, Object.assign({}, props)), children, _jsx(RenderErrorMessage, Object.assign({}, props))] }));
}
function RenderLabelAndHelpText(props) {
    const { input, label, helpBlock, required } = props;
    return (_jsxs("div", { className: "input-label-help-text-container", children: [label && (_jsx("label", { htmlFor: input.name, className: required ? "required" : "", children: label })), helpBlock && _jsx("span", { className: "help-block", children: helpBlock })] }));
}
function RenderErrorMessage(props) {
    const intl = useIntl();
    const { meta } = props;
    if ((!meta.error && !meta.submitError && !props.passwordStrengthMeter) || (!meta.touched && !meta.dirty)) {
        // no error, no message only for !props.passwordStrengthMeter
        return null;
    }
    const errorMsg = meta.error ? dynamicMessage(intl, meta.error) : null;
    let submitErrorMsg = null;
    if (meta.submitError && !meta.dirtySinceLastSubmit) {
        submitErrorMsg = dynamicMessage(intl, meta.submitError) || null;
    }
    return (_jsxs("div", { children: [_jsx("span", { role: "alert", tabIndex: -1, className: "input-validate-error", children: errorMsg || submitErrorMsg }), props.passwordStrengthMeter ? props.passwordStrengthMeter : null] }));
}
